export function setCookie(name: string, value: string, days = 365) {
  if (typeof window === 'undefined') {
    return;
  }
  const maxAge = days ? `; max-age=${days * 24 * 60 * 60}` : '';
  document.cookie = `${name}=${value || ''}${maxAge}; path=/; samesite=Lax; secure`;
}
